import {compose} from 'redux';
import checkAllowedSharing
  from '../../../../common/components/hoc-helpers/checkAllowedSharing';
import InspectedDatabasePage from './InspectedDatabasePage-redux';

export default compose(
  checkAllowedSharing
)(InspectedDatabasePage);
